"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Validator = void 0;

var definedRules = _interopRequireWildcard(require("./../rules"));

var _Eloquent = require("../utils/Eloquent");

var _Helper = require("../utils/Helper");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Validator = /*#__PURE__*/function () {
  function Validator() {
    _classCallCheck(this, Validator);

    _defineProperty(this, "errorsBag", void 0);

    _defineProperty(this, "customMessages", void 0);

    _defineProperty(this, "availableRules", void 0);

    _defineProperty(this, "componentInstance", void 0);
  }

  _createClass(Validator, [{
    key: "setComponentInstance",
    value: function setComponentInstance(instance) {
      this.errorsBag = [];
      this.customMessages = {};
      this.componentInstance = instance;
      this.availableRules = definedRules;
      return this;
    }
    /**
     * Check if the validations option is set on the component instance.
     *
     * @returns {boolean}
     */

  }, {
    key: "validationsNotDefined",
    value: function validationsNotDefined() {
      if (!this.componentInstance.$options.validations) {
        window.console.warn("The validations options is not defined.");
        return true;
      }

      return false;
    }
    /**
     * Return the default error messages.
     *
     * @returns {object}
     */

  }, {
    key: "getDefaultErrorMessages",
    value: function getDefaultErrorMessages() {
      return {
        after: 'This field must be a date after "{param}"',
        after_or_equal: 'This field must be a date after or equal to "{param}"',
        alpha: 'This field must only contain letters',
        alpha_dash: 'This field must only contain letters, dashes and underscores',
        alpha_numeric: 'This field must only contain letters and numbers',
        before: 'This field must be a date before "{param}"',
        before_or_equal: 'This field must be a date before or equal to "{param}"',
        "boolean": 'This field must be boolean',
        date: 'This field must be a valid date with the format YYYY-MM-DD',
        different: 'This field must be different than "{param}"',
        email: 'This field must be a valid email.',
        ens_with: 'This field must end with "{param}"',
        integer: 'This field must be a number.',
        is_array: 'This field must be an array',
        is_in: 'This field must be one of "{param}"',
        is_string: 'This field must be a string',
        json: 'This field must be a json object',
        length: 'The field length must be "{param}"',
        matches_regex: 'This field must match the regex "{param}"',
        max: 'This field must not be greater than "{param}"',
        min: 'This field must not be less than "{param}"',
        not_in: 'This field must not be one of "{param}"',
        numeric: 'This field must be numeric',
        required: 'This field is required',
        same: 'This field must be the same as "{param}"',
        starts_with: 'This field must start with "{param}"',
        url: 'This field must be a valid url',
        uuid: 'This field must be a valid uuid'
      };
    }
    /**
     * Get the error message.
     *
     * @param dataKey
     * @param rule
     * @param param
     * @returns {*}
     */

  }, {
    key: "getErrorMessage",
    value: function getErrorMessage(dataKey, rule, param) {
      var message = null;
      var key = dataKey + '.' + rule;
      var messages = this.getDefaultErrorMessages(); //get custom error message if exists

      if (this.customMessages.hasOwnProperty(key)) {
        message = this.customMessages[key];
      } else {
        message = messages[rule];
      }

      return message.replace('{param}', param);
    }
    /**
     * Set custom error messages.
     *
     * @param _customMessages
     * @returns {Validator}
     */

  }, {
    key: "setCustomErrorMessages",
    value: function setCustomErrorMessages(_customMessages) {
      if (_typeof(_customMessages) !== 'object') {
        window.console.warn('The validator customMessages must be an object');
        return this;
      }

      this.customMessages = _customMessages;
      return this;
    }
    /**
     * Add a message to the errorBag.
     *
     * @param dataKey
     * @param rule
     * @param errorMessage
     */

  }, {
    key: "addError",
    value: function addError(dataKey, rule, errorMessage) {
      var key = dataKey + '.' + rule;
      this.errorsBag.push({
        key: key,
        dataKey: dataKey,
        message: errorMessage
      });
    }
    /**
     * Validate a set of defined rules.
     *
     * @returns {Validator}
     */

  }, {
    key: "validate",
    value: function validate() {
      var _this = this;

      if (this.validationsNotDefined()) {
        return this;
      }

      this.errorsBag = [];
      var validationRules = this.componentInstance.$options.validations;
      var data = this.componentInstance.$data;

      var _loop = function _loop() {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            _dataKey = _Object$entries$_i[0],
            _rules = _Object$entries$_i[1];

        var value = (0, _Eloquent.find)(data, _dataKey);

        var rules = _rules.split('|');

        rules.forEach(function (rule, k) {
          rules[k] = rule.trim();
        });

        if (rules.includes('when_present') && !value) {
          return "continue";
        }

        rules.forEach(function (rule) {
          if (rule === 'when_present') return;

          _this.executeRule(rule.trim(), value, _dataKey);
        });
      };

      for (var _i = 0, _Object$entries = Object.entries(validationRules); _i < _Object$entries.length; _i++) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }

      this.componentInstance.$data.errorsBag = this.errorsBag;
      return this;
    }
    /**
     * Execute a rule and fill the errorBag.
     *
     * @param rule
     * @param value
     * @param dataKey
     *
     * @returns {boolean}
     */

  }, {
    key: "executeRule",
    value: function executeRule(rule, value, dataKey) {
      var arg = null;
      var data = this.componentInstance.$data; // for example: min:minLength (min is the rule and minLength is the component defined data property)

      if ((0, _Helper.hasArg)(rule)) {
        var str = rule.split(':');
        rule = str[0].trim();
        arg = str[1].trim();
        arg = (0, _Eloquent.find)(data, arg);
      }

      if (!this.availableRules[rule]) {
        window.console.warn('The rule "' + rule + '" for the data property "' + dataKey + '" is not defined.\n it will be ignored.');
        return false;
      }

      var errorMessage = this.getErrorMessage(dataKey, rule, arg);

      if (!this.availableRules[rule](value, arg)) {
        this.addError(dataKey, rule, errorMessage);
        return false;
      }

      return true;
    }
    /**
     * Check if the validation passes.
     *
     * @returns {boolean}
     */

  }, {
    key: "passes",
    value: function passes() {
      this.validate();
      return !this.errorsBag.length;
    }
    /**
     * Check if the validation fails.
     *
     * @returns {boolean}
     */

  }, {
    key: "fails",
    value: function fails() {
      return !this.passes();
    }
    /**
     * Add new rules at rune time for the Validator.
     *
     * @param name
     * @param closure
     * @returns {Validator}
     */

  }, {
    key: "extend",
    value: function extend(name, closure) {
      if (!name || !closure) {
        window.console.warn('Please pass a rule name as first argument and a closure function as a second argument for the extend() method');
        return this;
      }

      if (definedRules.hasOwnProperty(name)) {
        window.console.warn('The rule "' + name + '" exists.');
        return this;
      }

      if (typeof closure !== 'function') {
        window.console.warn('The closure of the rule "' + name + '" should be a function.');
        return this;
      }

      definedRules[name] = closure;
      this.availableRules = definedRules;
      return this;
    }
  }]);

  return Validator;
}();

exports.Validator = Validator;